import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import { beneBankLookUp } from "../../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { beneLookUp } from "../../../../../redux/features/verifyPAN/verifyPAN";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import "./index.css";

const ScheduleTransactionStepSelectAccount = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const unassignCategories = props?.categories;
  const [accountNumber, setAccountNumber] = useState(
    props?.txnPayLoad?.bankAccountNo ? props?.txnPayLoad?.bankAccountNo : "",
  );
  const [accountName, setAccountName] = useState(
    props?.txnPayLoad?.bankAccountName
      ? props?.txnPayLoad?.bankAccountName
      : "",
  );
  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );
  const [panNumber, setPanNumber] = useState(
    props?.txnPayLoad?.pan ? props?.txnPayLoad?.pan : null,
  );
  const [IFSC, setIFSC] = useState(
    props?.txnPayLoad?.bankAccountIFSC
      ? props?.txnPayLoad?.bankAccountIFSC
      : "",
  );
  const [bankLogo, setBankLogo] = useState(
    props?.txnPayLoad?.bankLogo ? props?.txnPayLoad?.bankLogo : "",
  );
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [remAccount, setRemAccount] = useState("");
  const [activeType, setActiveType] = useState("pan");
  const [disableCategories, setDisableCategories] = useState(true);

  const unassignlength = unassignCategories?.filter(
    (unassignCategory) => !props?.category?.includes(unassignCategory?.name),
  );

  const handleUnassignNavigate = (id) => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/categories/${id}`,
      { replace: false },
    );
  };

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };
  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    setAccountName(accountName);
    setAccountNumber(accountNumber);
    setIFSC(ifsc);
    setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    setPanNumber(panNo);
    props?.setSelectedCategory(null);

    dispatch(beneLookUp({ pan_number: panNo }));
    dispatch(
      beneBankLookUp({
        ifsc: ifsc,
        bank_account_no: accountNumber,
      }),
    );

    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      selectedCategory: null,
      amountWords: "",
      amount: "",
      mergeCategory: null,
    });
    handleCloseModal();
  };
  const handleCategorySelect = (categoryName) => {
    const categoryData = props?.categories?.find(
      (cat) => cat.name === categoryName,
    );

    if (props?.selectedCategory?.name === categoryName) {
      return;
    }

    props?.setSelectedCategory(categoryData);
    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({
      from: "Select",
      to: "Select",
    });
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setHyperLinks({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
  };

  return (
    <>
      <div className="max-w-tab-width-normal w-width-full mx-auto pt-padding-md Qsmd:pt-padding-lg pb-padding-md px-padding-md lg:px-padding-base">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={props.openOwner}
              setModalOpen={props.setOpenOwner}
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              shouldShowAssociatedAccounts={false}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div
            className={`w-width-full lg:max-w-[var(--create-box-width)] ${
              !props?.txnPayLoad?.ownerBankAccountNo
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            <SourceDestinationAccountDetail
              type="destination"
              flow="beneficiary"
              modalOpen={props.isModalOpen}
              setModalOpen={props.setIsModalOpen}
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              shouldShowAssociatedAccounts={false}
              handleOnAccountSelection={handleAccountSelection}
              activeType={activeType}
              setActiveType={setActiveType}
              setRemPan={setRemPan}
              setRemAccount={setRemAccount}
              setRemIFSC={setRemIFSC}
              remIFSC={remIFSC}
              remAccount={remAccount}
              remPan={remPan}
              flowType="scheduleCreate"
            />
          </div>

          <div className="flex flex-col gap-gap-md w-width-full lg:max-w-[var(--create-box-width)]">
            <NameFieldCard
              title={globalText?.SCHEDULE_NAME}
              placeholder={globalText?.NAME}
              note={globalText?.SCHEDULE_NOTE_MIN_LENGTH}
              fieldName="schedule_name"
              minLength={5}
              mode="strict"
              value={props?.txnPayLoad?.scheduleName}
              onChange={(val) =>
                props?.setTxnPayLoad({
                  ...props?.txnPayLoad,
                  scheduleName: val,
                })
              }
            />

            <ConfidentialCard
              icon={ICONS?.CONFIDENTIAL_TRANSACTION}
              title={globalText?.CREATE_AS_CONFIDENTIAL}
              note={globalText?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={props?.isConfidential}
              onToggle={() => props?.setIsConfidential(!props?.isConfidential)}
            />
          </div>

          <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-md">
            <CategorySelector
              beneAccountId={beneAccountId}
              category={props?.category}
              selectedCategory={props?.selectedCategory}
              unassignCategories={unassignCategories}
              unassignlength={unassignlength}
              disableCategories={disableCategories}
              handleCategorySelect={handleCategorySelect}
              handleUnassignNavigate={handleUnassignNavigate}
              previewMode={false}
              enableSearch
              showUnassignCTA={true}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleTransactionStepSelectAccount;
